const HeroSection = () => {
    return (
        <section className="relative overflow-hidden pt-24 pb-6 md:pt-28 md:pb-8">
            {/* Animated background gradient blobs */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
                <div
                    className="absolute w-[72%] h-[80%] right-[-25%] top-[-15%] animate-drift-1"
                    style={{
                        background:
                            "radial-gradient(50% 55% at 50% 50%, hsla(152,100%,35%,0.29), hsla(152,100%,35%,0.12) 40%, hsla(152,100%,35%,0) 65%)",
                    }}
                />
                <div
                    className="absolute w-[95%] h-[105%] left-[-35%] top-[-30%] animate-drift-2"
                    style={{
                        background:
                            "radial-gradient(55% 55% at 50% 50%, hsla(226,97%,28%,0.56), hsla(226,97%,28%,0.22) 45%, hsla(226,97%,28%,0) 68%)",
                    }}
                />
                <div
                    className="absolute w-[100%] h-[100%] left-[10%] bottom-[-30%] animate-drift-3"
                    style={{
                        background:
                            "radial-gradient(50% 55% at 50% 50%, hsla(14,95%,23%,0.44), hsla(14,95%,23%,0.18) 45%, hsla(14,95%,23%,0) 68%)",
                    }}
                />
            </div>
            {/* Bottom fade for smooth transition — sits behind the content (no
                z-10) so it fades the background without darkening the button. */}
            <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-b from-transparent to-background pointer-events-none" />

            <div className="relative w-full mx-auto px-6 sm:px-[5%] lg:px-[10%]">
                <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
                    <p className="mb-4 sm:mb-5 font-light tracking-wide bg-gradient-to-r from-[#00FFFF] to-[#FF63FF] bg-clip-text text-transparent text-sm sm:text-base md:text-lg leading-[1.8] sm:leading-[2] pb-2">
                        make every{" "}
                        <span
                            className="text-base sm:text-xl md:text-2xl px-[6px] pl-[2px] pr-[8px] inline-block align-middle"
                            style={{ fontFamily: "'Brittany Signature', cursive" }}
                        >
                            product
                        </span>{" "}
                        look{" "}
                        <span
                            className="text-base sm:text-xl md:text-2xl inline-block align-middle"
                            style={{ fontFamily: "'Brittany Signature', cursive" }}
                        >
                            iconic
                        </span>
                    </p>

                    <h1 className="font-light leading-[1.0125] tracking-tight text-foreground text-[2.025rem] sm:text-[2.3085rem] md:text-[3.078rem] lg:text-[3.8475rem]">
                        <span className="block">Your <span className="font-bold">always-on</span></span>
                        <span className="font-bold block"><span className="text-primary">AI creative</span> team</span>
                    </h1>

                    <p className="max-w-2xl mx-auto text-sm text-muted-foreground sm:text-base mt-4">
                        One platform to run your entire creative workflow,
                        scroll-stopping, conversion-ready photos, videos, and ads in
                        seconds. No shoots, no models, no editing.
                    </p>

                    <div className="mt-6 sm:mt-8">
                        <a
                            href="https://app.pixro.ai/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center rounded-2xl bg-primary text-primary-foreground px-8 py-4 sm:py-5 text-base sm:text-lg font-semibold hover:bg-primary/90 transition-colors w-full sm:w-auto sm:min-w-[320px]"
                        >
                            Start creating now for free
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
